<template>
  <div class="olympiad-banner">
    <h1>онлайн-олимпиады</h1>
    <h2>проверяйте свои знания и&nbsp;выигрывайте ценные призы!</h2>
  </div>
</template>

<script>
export default {
  name: 'OlympiadBanner',
};
</script>

<style scoped lang="scss">

.olympiad-banner {
  height: calc(var(--scale) * 350);
  border-radius: calc(var(--scale) * 60);
  padding: calc(var(--scale) * 32) calc(var(--scale) * 40);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  background-image: url("/img/materials/olympiad/banner.webp");
  background-size: cover;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 320);
    padding: calc(var(--scale) * 20) calc(var(--scale) * 16) calc(var(--scale) * 20) calc(var(--scale) * 18);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/img/materials/olympiad/banner-tablet.webp");
  }

  @include media-down($size-mobile) {
    padding: calc(var(--scale) * 20) 0;
    flex-direction: column-reverse;
    background-image: url("/img/materials/olympiad/banner-mob.webp");
  }

  h1 {
    width: calc(var(--scale) * 620);
    font-weight: 500;
    font-size: calc(var(--scale) * 120);
    line-height: 80%;
    letter-spacing: -0.06em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 334);
      font-size: calc(var(--scale) * 62);
      line-height: 70%;
    }

    @include media-down($size-mobile) {
      width: 100%;
      padding-inline: calc(var(--scale) * 12) calc(var(--scale) * 20);
      font-size: calc(var(--scale) * 54);
    }
  }

  h2 {
    width: calc(var(--scale) * 686);
    font-weight: 500;
    font-size: calc(var(--scale) * 48);
    line-height: 110%;
    text-align: right;
    letter-spacing: -0.02em;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 334);
      font-size: calc(var(--scale) * 20);
    }

    @include media-down($size-mobile) {
      width: 100%;
      padding-inline: calc(var(--scale) * 16);
      text-align: left;
    }
  }
}

</style>
